<p class="laft-form--title">Procesos o investigaciones</p>
<form class="laft-form" [formGroup]="investigationDataForm">
  <section class="laft-form--group">
    <p class="laft-form--group-title">
      Estás o has sido <span class="bold-700">investigado</span>, <span class="bold-700">procesado</span> o
      <span class="bold-700">condenado</span> por delitos como:
    </p>
    <div class="laft-form--investigation-list">
      <span class="laft-form--investigation-item">Lavado de activos</span>
      <span class="laft-form--investigation-item">Corrupción</span>
      <span class="laft-form--investigation-item">Terrorismo</span>
      <span class="laft-form--investigation-item">Nacrotráfico</span>
      <span class="laft-form--investigation-item">Extorsión</span>
      <span class="laft-form--investigation-item">Minería ilegal</span>
      <span class="laft-form--investigation-item">Delitos contra la administración pública</span>
      <span class="laft-form--investigation-item">Defraudación tributaria</span>
      <span class="laft-form--investigation-item">Conexos a criminalidad organizada</span>
    </div>
    <mat-radio-group class="laft-form--radio-button" formControlName="isInvestigated">
      <mat-radio-button [value]="false"><span class="laft-form-option">No</span></mat-radio-button>
      <mat-radio-button [value]="true"><span class="laft-form-option">Sí</span></mat-radio-button>
    </mat-radio-group>
    <div *ngIf="this.investigationDataForm.get('isInvestigated')?.value" class="laft-form--input-group">
      <div class="form-group-2 u-mb-1">
        <app-input
          class="laft-form--block-width"
          formControlName="prosecutorOffice"
          label="Fiscalía o juzgado"
        ></app-input>
        <app-input
          class="laft-form--block-width"
          formControlName="caseNumber"
          label="Nº Carpeta Fiscal / Expediente"
        ></app-input>
      </div>
      <div class="form-group-2">
        <app-select
          class="laft-form--block-width"
          formControlName="caseStatus"
          [options]="caseStatusOptions"
          valueField="value"
          textField="text"
          label="Estado del proceso / Resolución final"
        ></app-select>
        <app-input
          class="laft-form--block-width"
          formControlName="defendantName"
          label="Nombre del investigado, procesado o condenado"
        ></app-input>
      </div>
    </div>
  </section>
  <ng-container *ngIf="isLastStep">
    <app-section-message [text]="consents.DECLARATION_NOTICE" type="informative"></app-section-message>
    <section class="laft-form--checkbox">
      <app-checkbox
        [content]="consents.CONTRACT"
        formControlName="acceptsContract"
        errorMessage="Requerido"
      ></app-checkbox>
      <app-checkbox [content]="consents.COMMERCIAL_USE" formControlName="acceptsCommercialUse"></app-checkbox>
    </section>
  </ng-container>
  <div class="laft-form--actions">
    <button class="laft-form--btn-submit" type="button" (click)="onContinue()">
      {{ isLastStep ? 'Enviar información' : 'Continuar' }}
    </button>
  </div>
</form>
